import React, { useEffect, useState } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import axios from 'axios';
import ProductCard from '../../components/SspComponents/ProductCard';
import Layout from "../../layout/default";
import { useParams } from 'react-router-dom';

const ProductListing = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const { categoryId } = useParams(); // Get category ID from URL params

    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            try {
                const authToken = localStorage.getItem("authToken");
                const response = await axios.get(`${process.env.REACT_APP_HOST}api/product-variant-with-variants`, {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                    params: {
                        category_id: categoryId, // Use the category ID from URL params
                    },
                });
                
                // Filter products to only include those matching the category ID
                const filteredProducts = response.data.data.data.filter(product => 
                    product.category_id === parseInt(categoryId)
                );
                setProducts(filteredProducts);
            } catch (error) {
                console.error('Error fetching products:', error);
                setProducts([]);
            } finally {
                setLoading(false);
            }
        };

        if (categoryId) {
            fetchProducts();
        }
    }, [categoryId]);

    return (
        <Layout title="Product Listing" content="container">
            <div>
                <h1>Product Listing</h1>
                <Row className="g-4">
                    {loading ? (
                        <Col className="text-center">
                            <Spinner animation="border" variant="secondary" />
                        </Col>
                    ) : products.length === 0 ? (
                        <Col className="text-center">
                            <h5>No products available for this category.</h5>
                        </Col>
                    ) : (
                        products.map((product) => {
                            const hasVariants = product.product_variants && product.product_variants.length > 0;
                            return (
                                <ProductCard
                                    key={hasVariants ? product.product_variants[0].product_variant_id : product.product_id}
                                    product_id={product.product_id}
                                    title={product.title}
                                    description={product.description}
                                    image_url={product.image_url || 'default-image-url.jpg'}
                                    unit_quantity={hasVariants ? product.product_variants.map(variant => variant.unit_quantity) : []}
                                    unit_title={hasVariants ? product.product_variants.map(variant => variant.unit_title) : []}
                                    variants={hasVariants ? product.product_variants : []}
                                />
                            );
                        })
                    )}
                </Row>
            </div>
        </Layout>
    );
};

export default ProductListing;
